import React from "react";
import "./PaperTypeTabContent.css";
import CommonHeadingBeforeAfterLine from "../../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine";
import HeartIconComponent from "../../../Common-Component/HeartIconComponent/HeartIconComponent";

const PaperTypeTabContent = ({ product }) => {
  const data = [
    {
      title: "Standard Coated Paper",
      descn: "Standard Cards are simple business cards with great durability.",
      img: "/assets/Images/papertypes/img1.png",
    },
    {
      title: "Textured Paper",
      descn:
        "Textured card has the aesthetic effect of adding sophistication to your card.",
      img: "/assets/Images/papertypes/img2.png",
    },
    {
      title: "Metallic Paper",
      descn:
        "Matallic cards are strong, rasty, and adda premium lock to your business card",
      img: "/assets/Images/papertypes/img3.png",
    },
    {
      title: "Spot UV",
      descn: "Standard Cards are simple business cards with great durability.",
      img: "/assets/Images/papertypes/img1.png",
    },
    {
      title: "Non-Tearable Paper",
      descn: "Standard Cards are simple business cards with great durability.",
      img: "/assets/Images/papertypes/img2.png",
    },
    {
      title: "Special Textured Paper",
      descn: "Standard Cards are simple business cards with great durability.",
      img: "/assets/Images/papertypes/img3.png",
    },
  ];

  return (
    <section className="PaperTypeTabContent">
      <div className="main_content_holder">
        <div className="heading_div">
          <CommonHeadingBeforeAfterLine headingText="Materials" />
        </div>

        <div className="paper_types_div">
          <div className="row">
            {[
              ...new Map(
                product?.Product_Combinations?.map((item) => [
                  item?.Material?.id,
                  item,
                ])
              ).values(),
            ].map((item) => (
              <div
                className="col-lg-4 col-md-4 col-sm-6 d-flex justify-content-center"
                key={item?.Material?.id}
              >
                <div className="paper_type_card">
                  <div className="img_holder">
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL + item?.Material?.image
                      }
                      className="paper_img"
                      alt={item?.Material?.name}
                    />
                  </div>

                  <div className="text_holder">
                    <p className="paper_type_heading">{item?.Material?.name}</p>
                    <p className="descn">{item?.Material?.description}</p>
                  </div>

                  <div className="heart_icon_div">
                    <HeartIconComponent />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaperTypeTabContent;
